module.exports = ":host(){max-height:100vh}"